export default __webpack_public_path__ + "images/example1.png?d4ac3b9b3bb47a484949aa17617f7230";